import React from "react";
import { Box } from "@mui/material";
import LGModalCrud from "../LGCrud/LGModalCrud";
import { useCompany } from "../../contexts/CompanyContext";
import {
  deleteClientWarehouse,
  getClientWarehouseList,
} from "../../api/client";
import CreateClientWarehouseForm from "./ClientWarehouseForm/CreateClientWarehouseForm";
import UpdateClientWarehouseForm from "./ClientWarehouseForm/UpdateClientWarehouseForm";

export default function CrudClientWarehouse(): JSX.Element | null {
  const { selectedCompany } = useCompany();
  const companyId = selectedCompany?.id;

  if (!companyId) return null;

  return (
    <Box width={"100%"}>
      <LGModalCrud
        props={{
          actions: ["create", "update", "delete"],
          data: { companyId },
          fetchFunction: getClientWarehouseList,
          deleteFunction: deleteClientWarehouse,
          search: true,
          columns: [
            {
              field: "name",
              headerName: "Nombre",
              flex: 0.4,
            },
            {
              field: "client",
              headerName: "Cliente",
              flex: 0.3,
              valueGetter: (_value, row) => row?.client?.name || "-",
            },
            {
              field: "street",
              headerName: "Calle",
              flex: 0.3,
              valueGetter: (_value, row) => row?.address?.street || "-",
            },
            {
              field: "municipality",
              headerName: "Municipio",
              flex: 0.3,
              valueGetter: (_value, row) => row?.address?.municipality || "-",
            },
            {
              field: "state",
              headerName: "Estado",
              flex: 0.2,
              valueGetter: (_value, row) => row?.address?.state || "-",
            },
          ],
          addModalData: {
            header: "Agregar almacén de cliente",
            body: <CreateClientWarehouseForm companyId={companyId} />,
          },
          editModalData: {
            header: "Editar almacén de cliente",
            body: <UpdateClientWarehouseForm />,
          },
        }}
      />
    </Box>
  );
}
